var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ButtonToggleGroupComponent",
    {
      staticClass: "editor-object-selector-view",
      class: _vm.computedClasses,
      style: _vm.computedStyles,
      attrs: { value: _vm.internalValue ? _vm.internalValue.id : undefined },
      on: { change: _vm.onChange },
    },
    _vm._l(_vm.internalObjects, function (object) {
      return _c("ButtonToggleComponent", {
        key: object.id,
        attrs: { value: object.id, variant: "big" },
        nativeOn: {
          mouseenter: function ($event) {
            return _vm.onMouseEnter(object)
          },
          mouseleave: function ($event) {
            return _vm.onMouseLeave(object)
          },
        },
        scopedSlots: _vm._u(
          [
            object.type === "photo"
              ? {
                  key: "content",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "editor-object-selector-view-photo",
                        style: _vm.computedObjectPhotoStyles,
                        attrs: { src: _vm.getObjectPhotoUrl(object) },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : {
                  key: "default",
                  fn: function () {
                    return [_vm._v(_vm._s(object.text))]
                  },
                  proxy: true,
                },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }